import useDealerProvincePricing from '../../../utils/hooks/useDealerProvincePricing';
import useFetchMultiplePayments from '../../../core/apiHooks/useFetchMultiplePayments';
import useSelectLoyaltyOfferKeyByTrim from '../../../core/apiHooks/useSelectLoyaltyOfferKeyByTrim';
import { selectPrimaryCalculatorPaymentOptions } from '../../../core/reducers/financialCalculators';
import { useAppSelector } from '../../../core/utils';
export const useFirstTransmissionPayments = (trims, shouldFetch) => {
    const { dealerProvinceCode, isSellingPriceProvince } = useDealerProvincePricing();
    const primaryCalculatorPaymentOptions = useAppSelector(selectPrimaryCalculatorPaymentOptions);
    const defaultLoyaltyOfferKey = primaryCalculatorPaymentOptions.loyaltyOfferKey;
    const selectLoyaltyOfferKeyByTrim = useSelectLoyaltyOfferKeyByTrim(defaultLoyaltyOfferKey);
    const paymentRequests = trims.map(trim => {
        var _a, _b;
        return ({
            modelKey: trim.modelKey,
            modelYear: trim.modelYear,
            trimKey: trim.trimKey,
            transmissionKey: trim.defaultTransmission,
            exteriorColorKey: (_a = trim.transmissions[0]) === null || _a === void 0 ? void 0 : _a.exteriorColorKey,
            interiorColorKey: (_b = trim.transmissions[0]) === null || _b === void 0 ? void 0 : _b.interiorColorKey,
            accessories: [],
            protections: [],
            protectionAddOns: [],
        });
    });
    const defaultPaymentOptions = trims.map(transmission => {
        const loyaltyOfferKey = selectLoyaltyOfferKeyByTrim(transmission.trimKey);
        // set flag based on dealer province
        return {
            ...primaryCalculatorPaymentOptions,
            loyaltyOfferKey,
            overriddenIsSellingProvince: isSellingPriceProvince,
        };
    });
    return useFetchMultiplePayments(paymentRequests, shouldFetch, defaultPaymentOptions, undefined, dealerProvinceCode);
};
export default useFirstTransmissionPayments;
